// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1i2ZM","unreadBadge":"styles_unreadBadge__2N3Xp","modalContent":"styles_modalContent__1n6NT","modal":"styles_modal__2kbNp"};